import dayjs from 'dayjs';

export default class DateUtil {
    private static dateFormat: string = 'DD/MM/YYYY';

    public static formatDate(date: any): string | undefined {
        if (!date || (date.toString() === 'Invalid Date')) {
            return '';
        }
        return DateUtil._safeParse(date)?.format(DateUtil.dateFormat);
    }

    public static formatForApi(date: any, legacyFormat: string = 'unknown'): string | undefined {
        if (!date || (date.toString() === 'Invalid Date')) {
            return undefined;
        }
        return DateUtil._safeParse(date)?.toISOString();
    }

    private static _safeParse(date: any): dayjs.Dayjs | undefined {
        if (!date) {
            return undefined;
        }

        if (typeof date !== 'string') {
            // assume Date or dayjs.DayJs
            return dayjs(date);
        }

        if (date.includes('GMT')) {
            return dayjs(date);
        }

        const parsedDate = dayjs(date, 'DD/MM/YYYY', true);
        if (parsedDate.isValid()) {
            return parsedDate;
        }

        return dayjs(date);
    }

    public static parseToDate(input: any): Date | undefined {
        if (!input) {
            return undefined;
        }
        const date = Array.isArray(input) ? input[0] : input;
        const parsed = DateUtil._safeParse(date);
        if (!parsed) {
            return undefined;
        }
        return parsed.toDate();
    }
}
